import { render, staticRenderFns } from "./campusrosterFollow.vue?vue&type=template&id=c8d1dd78"
import script from "./campusrosterFollow.vue?vue&type=script&lang=js"
export * from "./campusrosterFollow.vue?vue&type=script&lang=js"
import style0 from "./campusrosterFollow.vue?vue&type=style&index=0&id=c8d1dd78&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports